<template>
  <div class="leads">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs3 md2 v-if="leadsDetails2.length">
              <div class="ml-4 grey--text text--darken-2">{{ $t('leadsVisitors') | cap }}</div>
              <div class="ml-4 headline teal--text">{{ returningLead }}</div>
            </v-flex>
            <v-flex xs6 md2>
              <div class="ml-4 grey--text text--darken-2">{{ $t('newLeads') | cap }}</div>
              <div class="ml-4 headline grey--text">{{ totalLeads }}</div>
            </v-flex>
            <v-flex xs6 md2>
              <div class="ml-4 grey--text text--darken-2">{{ $t('chatsTotal') | cap }}</div>
              <div class="ml-4 headline grey--text">{{ nbChats }}</div>
            </v-flex>
            <v-flex xs6 md2>
              <div class="ml-4 grey--text text--darken-2">{{ $t('conversionRate') + ' conseiller' | cap }}</div>
              <div class="ml-4 headline primary--text">{{ conversionAgentChat }} %</div>
            </v-flex>
            <v-flex xs6 md2 v-if="brideMenu('stats_chatbot') === '1'">
              <div class="ml-4 grey--text text--darken-2">{{ $t('conversionRate') + ' bot' | cap }}</div>
              <div class="ml-4 headline primary--text">{{ conversionBotChat }} %</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <highcharts :options="options"></highcharts>
            </v-flex>
            <!--
            <v-flex xs6 md3>
                <highcharts :options="options"></highcharts>
            </v-flex>
            -->
          </v-layout>
          <v-layout row wrap>
            <v-flex xs3 md2>
              <div class="ml-4 grey--text text--darken-2">{{ '(Conseiller)' | cap }}</div>
              <div class="ml-4 headline purple--text">{{ totalLeadsAgent }}</div>
            </v-flex>
            <v-flex xs3 md2 v-if="leadsDetails2.length && brideMenu('stats_chatbot') === '1'">
              <div class="ml-4 grey--text text--darken-2">{{ '(Chatbot)' | cap }}</div>
              <div class="ml-4 headline blue--text">{{ totalLeadsBot }}</div>
            </v-flex>
            <v-flex xs3 md2>
              <div class="ml-4 grey--text text--darken-2">{{ '(Formulaire)' | cap }}</div>
              <div class="ml-4 headline orange--text">{{ totalLeadsForm }}</div>
            </v-flex>
            <v-flex xs3 md2 v-if="brideMenu('stats_callback') === '1'">
              <div class="ml-4 grey--text text--darken-2">{{ '(Call back)' | cap }}</div>
              <div class="ml-4 headline brown--text">{{ totalLeadsC2c }}</div>
            </v-flex>
            <v-flex xs3 md2 v-if="brideMenu('parametre_recall') === '1'">
              <div class="ml-4 grey--text text--darken-2">{{ '(Meeting)' | cap }}</div>
              <div class="ml-4 headline blue-grey--text">{{ totalLeadsMeeting }}</div>
            </v-flex>
            <v-flex xs3 md2>
              <div class="ml-4 grey--text text--darken-2">{{ '(Autres)' | cap }}</div>
              <div class="ml-4 headline green--text">{{ totalLeadsAutre }}</div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- <v-btn flat @click="getLeadsInfos()" color="accent">
        {{!leadsDetails.length ? 'Afficher' : 'Actualiser'}} les leads (long)
        <v-icon right>{{ !leadsDetails.length ? 'remove_red_eye' : 'refresh' }}</v-icon>
      </v-btn> -->
      <!--
      <v-card class="mb-3" v-if="leadsDetails.length || nbCreations">
        <v-card-text>
          <v-toolbar class="elevation-0" color="white">
            <v-toolbar-title>{{ $t('leadsDetails') | cap }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="download()"
              :disabled="leadsDetails.length == 0"
            >
              {{ $t('exportInCsv') }}
              <v-icon v-if="nbVisits > 500" color="primary" right>visibility</v-icon>
              <v-icon v-else color="primary" right>file_download</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex xs12 md6 lg3 class="mt-3" v-if="false">
              <v-checkbox
                color="primary"
                :label="$tc('leads', 2, {count: ''}) + ' ' + $t('ofThePeriod') | cap"
                v-model="leadsOfPeriod"
                class="primary--text"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md6 lg3 class="mt-3">
              <v-checkbox
                color="primary"
                label="Uniquement leads créés"
                v-model="onlyCreatedLeads"
                class="primary--text"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 md3 class="mt-3"
              v-if="brideMenu('stats_leads_getquanty') === '1'"
            >
              <v-checkbox
                color="primary"
                label="GetQuanty"
                v-model="getquanty"
                class="primary--text"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 md3 class="mt-3">
              <v-checkbox
                color="primary"
                :label="$t('callback') | cap"
                v-model="C2C"
                class="primary--text"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-autocomplete 
                :items="motifs" 
                v-model="motif"
                :label="$tc('tags', 2, {count: ''}) | cap"
                clearable
                append-icon="label"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                append-icon="search"
                :label="$t('search')"
                hide-details
                clearable
                v-model="search"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headersLeadsDetails"
            :items="leadsDetails"
            :no-data-text="$tc('leads', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25]"
            :rows-per-page-text="$t('leadsPerPage')"
            :search="search"
            :custom-filter="filterLeads"
            :custom-sort="sort"
            :pagination.sync="pagination">
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.creation }}</td>
              <td class="text-xs-left">{{ props.item.last }}</td>
              <td
                v-if="brideMenu('stats_leads_chaleur') === '1'"
               class="text-xs-right"
               >{{ chaleur(props.item.id) }}</td>
              <td 
                v-if="brideMenu('stats_leads_getquanty') === '1'"
                class="text-xs-left"
              >
                {{ 
                  props.item.getquanty['raison sociale']
                  ? props.item.getquanty['raison sociale'][1]
                  : ''
                }}
              </td>
              <td class="text-xs-left">{{ props.item.company }}</td>
              <td>{{ props.item.gender }} {{ props.item.fname }} {{ props.item.lname }} <span class="font-italic grey--text text--darken-1">{{ props.item.id }}</span></td>
              <td class="text-xs-right">{{ props.item.duration | duration }}</td>
              <td class="text-xs-left">{{ props.item.site }}</td>
              <td class="text-xs-left">{{ props.item.motifToShow }}</td>
              <td class="text-xs-left">{{ agentIdToAgentName(props.item.agent)[props.index] }}</td>
              <td class="text-xs-right px-0">
                <v-btn icon flat @click.stop="openDialogEdit(props.item)">
                  <v-icon>info_outline</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-right px-0">
                <v-btn icon flat @click.stop="openDialogRemove(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-right px-0">
                <v-menu>
                  <v-btn icon flat slot="activator">
                    <v-icon>share</v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile @click="leadMail(props.item)">
                      <v-list-tile-title>{{ $t('sendByEmail') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="leadZendesk(props.item)">
                      <v-list-tile-title>{{ $t('createAZendeskTicket') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="leadSalesForce(props.item)">
                      <v-list-tile-title>{{ $t('exportToSalesForce') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop, itemsLength }">
              {{ pageStart }}-{{ pageStop }} sur {{ itemsLength }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
  -->

     <v-card class="mb-3" v-if="leadsDetails2.length || nbCreations">
        <v-card-text>
          <v-toolbar class="elevation-0" color="white">
            <v-toolbar-title>{{ $t('leadsDetails') | cap }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="download()"
              :disabled="leadsDetails2.length == 0"
            >
              {{ $t('exportInCsv') }}
              <v-icon v-if="nbVisits > 500" color="primary" right>visibility</v-icon>
              <v-icon v-else color="primary" right>file_download</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex xs6 sm2 md3 class="mt-2">
              <v-checkbox
                color="primary"
                label="Returning Leads"
                v-model="sourceReturning"
                class="primary--text returningLeads"
                hide-details
              ></v-checkbox>
              <!-- :disabled="!leadsOfPeriod" -->
            </v-flex>
            <v-flex xs6 md3>
              
            </v-flex>

            <v-flex xs12 md3>
              <v-flex xs10 >
                <v-autocomplete 
                  :items="motifs" 
                  v-model="motif"
                  :label="$tc('tags', 2, {count: ''}) | cap"
                  clearable
                  append-icon="label"
                ></v-autocomplete>
              </v-flex>
            </v-flex>

            <v-flex xs12 md3>
              <v-flex xs10 >
                <v-text-field
                  append-icon="search"
                  :label="$t('search')"
                  hide-details
                  clearable
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs3 sm2>
              <v-subheader v-text="'Voir uniquement les leads :'"></v-subheader>
            </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 " v-if="false">
                <v-checkbox
                  color="primary"
                  :label="$tc('leads', 2, {count: ''}) + ' ' + $t('ofThePeriod') | cap"
                  v-model="leadsOfPeriod"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 ">
                <v-checkbox
                  color="primary"
                  label="Conseiller "
                  v-model="sourceAgent"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
                <!-- :disabled="!leadsOfPeriod" -->
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 " v-if="brideMenu('stats_chatbot') === '1'">
                <v-checkbox
                  color="primary "
                  label="Chatbot "
                  v-model="sourceBot"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
                <!-- :disabled="!leadsOfPeriod" -->
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 ">
                <v-checkbox
                  color="primary"
                  label="Formulaire "
                  v-model="sourceForm"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
                <!-- :disabled="!leadsOfPeriod" -->
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 " v-if="brideMenu('stats_callback') === '1'">
                <v-checkbox
                  color="primary"
                  :label="$t('callback') | cap "
                  v-model="C2C"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 " v-if="brideMenu('parametre_recall') === '1'">
                <v-checkbox
                  color="primary"
                  label="Meeting "
                  v-model="sourceRecall"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 sm2 md1 class="mt-2 " v-if="brideMenu('stats_leads_getquanty') === '1'" >
                <v-checkbox
                  color="primary"
                  label="GetQuanty "
                  v-model="getquanty"
                  class="primary--text choixLead"
                  hide-details
                ></v-checkbox>
              </v-flex>
          </v-layout>

          <v-data-table
            :headers="headersLeadsDetails"
            :items="leadsDetails2"
            :no-data-text="$tc('leads', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25, 100]"
            :rows-per-page-text="$t('leadsPerPage')"
            :search="search"
            :custom-filter="filterLeads"
            :custom-sort="sort"
            :dark=false
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>

            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-left">{{ props.item.creation }}</td>
                <td class="text-xs-left">{{ props.item.last }}</td>
                <td
                  v-if="brideMenu('stats_leads_chaleur') === '1'"
                class="text-xs-right"
                >{{ chaleur(props.item.id) }}</td>
                <td 
                  v-if="brideMenu('stats_leads_getquanty') === '1'"
                  class="text-xs-left"
                >
                  {{ 
                    props.item.getquanty['raison sociale']
                    ? props.item.getquanty['raison sociale'][1]
                    : ''
                  }}
                </td>
                <td class="text-xs-left">{{ props.item.company }}</td>
                <td>{{ props.item.gender }} {{ props.item.firstName }} {{ props.item.lastName }} <span class="font-italic grey--text text--darken-1">({{props.item.id}})</span></td>
                <td class="text-xs-right">{{ props.item.duration | duration }}</td>
                <td v-if="totalSite > 1" class="text-xs-left">{{ props.item.site }}</td>
                <td class="text-xs-left">{{ props.item.motifToShow }}</td>
                <!-- <td class="text-xs-left">{{ agentIdToAgentName(props.item.agent)[0] }}</td> -->
                <td class="text-xs-left">{{ props.item.source }}<br><i v-if="agentIdToAgentName(props.item.agent)[0] !== ''">({{ agentIdToAgentName(props.item.agent)[0] }})</i></td>
                <td class="text-xs-right px-0">
                  <v-btn icon flat @click.stop="openDialogEdit(props.item)">
                    <v-icon>info_outline</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-right px-0">
                  <v-btn icon flat @click.stop="openDialogRemove(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-right px-0">
                  <v-menu>
                    <v-btn icon flat slot="activator">
                      <v-icon>share</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="leadMail(props.item)">
                        <v-list-tile-title>{{ $t('sendByEmail') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="leadZendesk(props.item)">
                        <v-list-tile-title>{{ $t('createAZendeskTicket') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="leadSalesForce(props.item)">
                        <v-list-tile-title>{{ $t('exportToSalesForce') }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>

            <template slot="pageText" slot-scope="{ pageStart, pageStop, itemsLength }">
              {{ pageStart }}-{{ pageStop }} sur {{ itemsLength }}
            </template>
            
          </v-data-table>

        </v-card-text>
      </v-card>
    </div>

    <!-- DIALOGUES EDITEUR LEAD-->
    <v-dialog
      v-model="dialogEdit"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <wz-editeur-lead
        :leadDialog="leadDialog"
        :custom_motifs="custom_motifs"
        :custom_champs="custom_champs"
        :showHisto="true"
        :histoChat="true"
        @closeDialog="dialogEditeurRemove"
        @updateLead="updateLeadSubmit"
      ></wz-editeur-lead>
    </v-dialog>
    <!-- DIALOGUES REMOVE LEAD-->
    <v-dialog v-model="dialogRemove" max-width="290">
      <v-card>
        <v-card-title class="primary white--text title">{{ $t('delete') + ' ' + $tc('leads', 1, { count: '' }) + '?' | cap}}</v-card-title>
        <v-card-text>{{ $t('msgDeleteLead') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancelDialogRemove">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="submitDialogRemove">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { MOTIFS_NUXE, MOTIFS_INOYA } from '../../constants'
import _ from 'lodash'
import * as moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import json2csv from 'json2csv'
export default {
  data () {
    return {
      loading: false,

      resFromAjax: null,
      currentTab: 0,
      tabs: [
        { index: 0, name: this.$t('leadEditor'), icone: 'assignment' },
        { index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }
      ],
      nbLeads: 0,
      nbLeadsChat: 0,
      nbLeadsBot: 0,
      nbLeadsCallBack: 0,
      nbLeadsMeeting: 0,
      nbLeadsForm: 0,
      nbLeadsAutre: 0,
      nbVisits: 0,
      returningLead: 0,
      nbCreations: 0,
      totalAllLeads: 0,
      totalLeadsAgent: 0,
      totalChatsAgent: 0,
      totalLeadsBot: 0,
      totalLeadsForm: 0,
      totalLeadsC2c: 0,
      totalLeadsMeeting: 0,
      totalLeadsAutre: 0,
      nbChats: 0,
      nameChampsBot: [
        'bot_TF_rgpd',
        'bot_TF_main_search',
        'bot_TF_lieu',
        'bot_TF_departement',
        'bot_TF_lieuCP',
        'bot_TF_type',
        'bot_TF_nature',
        'bot_TF_surface',
        'bot_TF_nbpostes',
        'bot_TF_budget',
        'bot_tf_num',
        'bot_tf_full_name',
        'bot_tf_ouinon',
        'bot_tf_pagesvues',
        'bot_tf_typebusiness',
        'bot_tf_objectifprincipal',
        'bot_tf_resourcehumaineinternet',
        'bot_tf_effectif',
        'bot_tf_echeanceprojet'
      ],
      /* liste all bot
      nameChampsBot: [
        'bot_tf_num',
        'bot_tf_full_name',
        'bot_tf_lieu',
        'bot_tf_ouinon',
        'bot_tf_participants',
        'bot_tf_date_debut',
        'bot_tf_departement',
        'bot_tf_nb_jours',
        'bot_tf_superficie',
        'bot_tf_city',
        'bot_tf_dept',
        'bot_tf_zip',
        'bot_tf_region',
        'bot_tf_country',
        'bot_TF_rgpd',
        'bot_TF_main_search',
        'bot_TF_lieu',
        'bot_TF_departement',
        'bot_TF_lieuCP',
        'bot_TF_type',
        'bot_TF_nature',
        'bot_TF_surface',
        'bot_TF_nbpostes',
        'bot_TF_budget',
        'bot_tf_pagesvues',
        'bot_tf_typebusiness',
        'bot_tf_objectifprincipal',
        'bot_tf_resourcehumaineinternet',
        'bot_tf_effectif',
        'bot_tf_echeanceprojet'
      ],
      */
      /**
       * Indique que seuls les leads
       * de la période sont affichés
       * @type {Boolean}
       */
      leadsOfPeriod: true,
      /**
       * Indique que seuls les leads
       * créés sont affichés
       * @type {Boolean}
       */
      onlyCreatedLeads: false,
      options: {
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          // shared: true,
          borderColor: '#cccccc'
          // crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // grandes valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: 'rgba(0, 150, 136, 1)'
              }
            },
            title: {
              text: 'Returning leads',
              style: {
                color: 'rgba(0, 150, 136, 1)'
              }
            },
            opposite: true
          },
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: 'rgba(50, 50, 50, 1)' // gris
              }
            },
            title: {
              text: this.$t('chats2'),
              style: {
                color: 'rgba(50, 50, 50, 1)' // gris
              }
            },
            opposite: false
          }
        ],
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          enabled: false,
          y: 55,
          floating: true,
          backgroundColor: ('rgba(255,255,255,0.25)')
        },
        plotOptions: {
          series: {
            fillOpacity: 0.7
          },
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          }
        },
        series: [
          // {
          //   name: this.$t('newLeads'),
          //   type: 'column',
          //   color: 'rgba(233, 30, 99, 0.8)', // pink
          //   marker: {symbol: 'circle', enabled: false},
          //   visible: true,
          //   tooltip: { valueSuffix: '' },
          //   yAxis: 1,
          //   data: [] // à remplir par l'appel ajax
          // },
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -6
          }
        },
        credits: {
          enabled: false
        }
      },

      /**
       * variables liées au tableau du détails des leads
       */
      search: '',
      getquanty: false,
      C2C: false,
      meeting: false,
      sourceReturning: false,
      sourceAgent: false,
      sourceBot: false,
      sourceForm: false,
      sourceRecall: false,
      motif: null,
      pagination: {
        sortBy: 'last',
        descending: true
      },
      headersLeadsDetails: [
        { text: _.upperFirst(this.$t('exportCreation')), value: 'creation' },
        { text: _.upperFirst(this.$t('exportLast')), value: 'last' },
        { text: this.$t('leadHeat'), value: 'chaleur', sortable: false },
        { text: 'GetQuanty', value: 'getquanty', sortable: false },
        { text: _.upperFirst(this.$t('company')), value: 'company', sortable: false },
        { text: _.upperFirst(this.$t('identity')), value: 'identity', sortable: false },
        { text: _.upperFirst(this.$t('exportDuration')), value: 'duration' },
        { text: _.upperFirst(this.$t('exportSite')), value: 'site' },
        { text: _.upperFirst(this.$tc('tags', 2, {count: ''})), value: 'motif' },
        { text: _.upperFirst(this.$tc('sources', 2, {count: ''})), value: 'agent' },
        // { text: _.upperFirst(this.$tc('agents', 2, {count: ''})), value: 'agent' },
        { text: '', value: 'actions', sortable: false }
      ],
      leadsDetails: [],
      leadsDetails2: [],
      filteredLeads: null,

      /**
       * Gestion du lead dans le dialog
       * @type {Boolean}
       */
      dialogEdit2: false,
      dialogEdit: false,
      dialogRemove: false,
      leadDialog: {
        gender: '',
        motifs: []
      },
      custom_motifs: [],
      custom_champs: [],
      default_motif: [
        { text: _.upperFirst(this.$t('support')), value: 'support' },
        { text: _.upperFirst(this.$t('lead')), value: 'lead' },
        { text: _.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' },
        { text: _.upperFirst(this.$t('estimate')), value: 'devis' },
        { text: _.upperFirst(this.$t('reservation')), value: 'resa' },
        { text: _.upperFirst(this.$t('contact')), value: 'contact' }
      ]
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapGetters('_Sites', ['GET_SITE_BY_ID']),
    ...mapState('_User', ['brides']),
    identities () {
      return this.leadsDetails2.map(item => {
        return _.isEmpty(item.fname) && _.isEmpty(item.lname)
        ? '#' + item.id
        : item.gender + ' ' + item.fname + ' ' + item.lname
      })
    },
    // conversionChat () {
    //   return this.nbChats !== 0
    //   ? _.round(((this.nbCreations / this.nbChats) * 100), 2)
    //   : 0
    // },
    conversionAgentChat () {
      return this.nbChats !== 0
      ? _.round(((this.totalLeadsAgent / this.totalChatsAgent) * 100), 2)
      : 0
    },
    conversionBotChat () {
      return this.nbChats !== 0
      ? _.round(((this.totalLeadsBot / this.nbChats) * 100), 2)
      : 0
    },
    totalLeads () {
      return (this.totalLeadsAgent + this.totalLeadsBot + this.totalLeadsForm + this.totalLeadsC2c + this.totalLeadsMeeting + this.totalLeadsAutre)
    },
    totalSite () {
      return this.$store.state._User.licAllKeys.length
    },
    motifs () {
      // NUXE
      if (this.$store.state._User.entKey === '9f1d52167b4128993ffa1c7b92207c4c') {
        return MOTIFS_NUXE
      }
      // INOYA
      if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7') {
        return MOTIFS_INOYA
      }
      // recupere tous le motif de chaque lead
      // mais pas encore dans la liste des motifs de chaque lead
      // console.log('this.leadsDetails2.motifs', this.leadsDetails2.motifs)
      let res = []
      if (!this.leadsDetails2.motifs) {
        let motifs = _.map(this.leadsDetails2, 'motif')
        motifs = _.filter(motifs, m => { return m.length })
        _.each(motifs, motif => {
          res.push(motif)
          // _.each(motif, m => {
          //   res.push(m)
          // })
        })
      }

      // console.log('_.uniq(res)', _.uniq(res))
      return _.uniq(res)
    },
    // leadDialogChaleur () {
    //   return this.chaleurLead(this.leadDialog)
    // },
    heightOfFiche () {
      return 'height: ' + (window.innerHeight - 300) + 'px'
    },
    heightOfHisto () {
      return 'height: ' + (window.innerHeight - 200) + 'px'
    }
  },

  mounted () {
    // si les filtres sont chargés, il est possible de lancer la/les requêtes afin de remplir les stats
    this.loading = true
    this.getLeadsInfos()
    // this.getChats()
    // this.getLeads()
    // si il n'y a qu'un seul site pour ce client
    if (this.totalSite < 2) {
      this.headersLeadsDetails.splice(7, 1) // retire le header 'site visité'
    }
    // retire getquanty si pas autorisé
    if (this.brideMenu('stats_leads_getquanty') !== '1') {
      this.headersLeadsDetails.splice(3, 1) // retire le header 'chaleur'
    }
    // retire la chaleur si pas autorisé
    if (this.brideMenu('stats_leads_chaleur') !== '1') {
      // console.log('headersLeadsDetails', this.headersLeadsDetails)
      this.headersLeadsDetails.splice(2, 1) // retire le header 'chaleur'
    }
  },

  created () {
  },

  methods: {
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    /**
     * Récupère les leads (visiteurs avec des informations)
     */
    getLeadsInfos () {
      this.loading = true
      // execution de la requête en fonction des filtres
      this.axios.get('get/leads.php?' + this.params)
      .then(response => {
        // console.log('lead - response', response)
        this.resFromAjax = response.data
        this.nbLeads = this.resFromAjax.leads2.length
        this.nbVisits = 0
        this.returningLead = 0
        this.nbCreations = 0
        this.totalLeadsAgent = 0
        this.totalLeadsBot = 0
        this.totalLeadsForm = 0
        this.totalLeadsC2c = 0
        this.totalLeadsMeeting = 0
        this.totalLeadsAutre = 0
        this.options.xAxis.categories = []
        this.options.series = [] // efface le tableau
        // construction du tableau series returning leads
        let serie0 = {
          name: 'Returning leads',
          type: 'area',
          color: 'rgba(0, 150, 136, 0.9)', // teal
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 0,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series leads agent
        let serie1 = {
          name: 'leads conseiller',
          type: 'column',
          color: 'rgba(156, 39, 176, 0.9)', // purple
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series leads bot
        let serie2 = {
          name: 'leads bot',
          type: 'column',
          color: 'rgba(33, 150, 243, 0.9)', // blue
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series leads form
        let serie3 = {
          name: 'leads formulaire',
          type: 'column',
          color: 'rgba(255, 152, 0, 0.9)', // orange
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series leads c2c
        let serie4 = {
          name: 'leads CallBack',
          type: 'column',
          color: 'rgba(121, 85, 72, 0.9)', // brown
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series leads meeting
        let serie5 = {
          name: 'Leads Meeting',
          type: 'column',
          color: 'rgba(6, 125, 139, 0.9)', // blue-grey
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series autres leads
        let serie6 = {
          name: 'Autres leads',
          type: 'column',
          color: 'rgba(76, 175, 80, 0.9)', // green
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] // à remplir par l'appel ajax
        }
        // construction du tableau series conversations
        let serie7 = {
          name: this.$t('chats2'),
          type: 'column',
          color: 'rgba(50, 50, 50, 0.7)', // gris
          // color: 'rgba(33, 150, 243, 0.8)', // primary
          marker: {symbol: 'circle', enabled: false},
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'allChats',
          yAxis: 1,
          pointPadding: 0,
          data: [] // à remplir par l'appel ajax
        }
        this.options.series[0] = serie0
        this.options.series[1] = serie1
        this.options.series[2] = serie2
        this.options.series[3] = serie3
        this.options.series[4] = serie4
        this.options.series[5] = serie5
        this.options.series[6] = serie6
        this.options.series[7] = serie7

        // this.options.series[0].data = [] // returning leads
        // this.options.series[1].data = [] // leads agent
        // if (this.brideMenu('stats_chatbot') === '1') {
        //   this.options.series[2].data = [] // leads bot
        // }
        // this.options.series[3].data = [] // leads form
        // if (this.brideMenu('stats_callback') === '1') {
        //   this.options.series[4].data = [] // leads c2c
        // }
        // if (this.brideMenu('parametre_recall') === '1') {
        //   this.options.series[5].data = [] // Leads meeting
        // }
        // this.options.series[6].data = [] // autre leads
        this.leadsDetails = []
        this.leadsDetails2 = []

        // informations du graphique
        _.each(this.resFromAjax.days2, day => {
          // infos jour par jour
          // this.options.xAxis.categories.push(moment(day.date).format('ll'))
          this.options.series[0].data.push(day.returningLead)
          // this.options.series[0].data.push(day.creations)
          this.options.series[1].data.push(day.leadsAgent)
          if (this.brideMenu('stats_chatbot') === '1') {
            this.options.series[2].data.push(day.leadsBot)
            this.totalLeadsBot += day.leadsBot
          }
          this.options.series[3].data.push(day.leadsForm)
          if (this.brideMenu('stats_callback') === '1') {
            this.options.series[4].data.push(day.leadsC2c)
            this.totalLeadsC2c += day.leadsC2c
          }
          if (this.brideMenu('parametre_recall') === '1') {
            this.options.series[5].data.push(day.leadsMeeting)
            this.totalLeadsMeeting += day.leadsMeeting
          }
          this.options.series[6].data.push(day.leadsAutre)

          this.nbVisits += day.visits
          this.returningLead += day.returningLead
          // infos pour la période
          if (day.leadsBot && this.brideMenu('stats_chatbot') !== '1') {
            // this.nbVisits -= day.leadsBot // rerire les leads bot du total
          } else if (day.leadsC2c && this.brideMenu('stats_callback') !== '1') {
            // this.nbVisits -= day.leadsC2c // rerire les leads c2c du total
          }
          this.nbCreations += day.creations
          this.totalLeadsAgent += day.leadsAgent

          this.totalLeadsForm += day.leadsForm

          this.totalLeadsAutre += day.leadsAutre
        })
/*
        // informations sur le détail des leads
        _.each(this.resFromAjax.leads, lead => {
          let infos = {}
          // pour chaque attributs du lead
          _.each(lead, (value, key) => {
            infos[key] = value
            // formatage s'il s'agit d'une date
            if (moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD') === value) {
              infos[key] = moment(value).format('L')
            }
          })
          // formatage des infos getquanty si autorisé
          if (this.brideMenu('stats_leads_getquanty') === '1') {
            try {
              infos['getquanty'] = JSON.parse(infos['getquanty'])
            } catch (e) {
              infos['getquanty'] = ''
            }
          } else {
            infos['getquanty'] = ''
          }

          // formatage du domain du site
          infos['siteId'] = infos['site']
          infos['site'] = this.GET_SITE_BY_ID(infos['site']).LIC_URL
          infos['site'] = new window.URL(infos['site']).hostname
          // infos['siteKey'] = infos['siteKey']
          infos['motifToShow'] = infos['motif']
          // console.log('infos lead', infos)

          // MOTIFS SPECIAUX ORPI
          if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
            for (let c in MOTIFS_ORPI) {
              if (MOTIFS_ORPI[c].value === infos['motif']) {
                infos['motifToShow'] = MOTIFS_ORPI[c].text
              }
            }
          }
          // uniquement pour
          // BNPPRE
          if (this.$store.state._User.entKey === 'adad9e37fb749c6884c852') {
            // let cloneInfos = _.cloneDeep(infos)
            // let testObjInfos = Object.keys(infos.champSup.name)// un tableau de cles champssup
            // ajoute les champsSup remplis
            // for (let a = 0; a < infos['champSup'].length; a++) {
            //   let name = infos['champSup'][a].name
            //   let val = infos['champSup'][a].value
            //   // let obj = '{' + name + ': ' + value + '}'
            //   infos[name] = val
            // }
            // ajoute les champsSup bot uniquement si pas encore dans l'objet "infos"
            for (let i = 0; i < this.nameChampsBot.length; i++) {
              let find = false
              // recheche si il existe deja une entrée dans l'object infos.champSup
              for (let a = 0; a < infos['champSup'].length; a++) {
                if (infos['champSup'][a].name === this.nameChampsBot[i]) {
                  let name = infos['champSup'][a].name
                  let val = infos['champSup'][a].value
                  // let obj = '{' + name + ': ' + value + '}'
                  infos[name] = val
                  find = true
                }
              }
              if (!find) {
                infos[this.nameChampsBot[i]] = ''
              }
              // let indexChamp = infos.champSup.findIndex(info => info.name === this.nameChampsBot[i])
              // // si pas encore present on l'ajoute sans valeur
              // if (indexChamp === -1) {
              //   infos[this.nameChampsBot[i]] = ''
              // // sinon on l'ajoute avec la valeur deja présente
              // // } else {
              //   // let name = infos['champSup'][indexChamp].name
              //   // let val = infos['champSup'][indexChamp].value
              //   // let obj = '{' + name + ': ' + value + '}'
              //   // infos[name] = val
              // }
            // var test = infos.find(infos, function (o) { return o === this.nameChampsBot[i] })
            }
            // infos = cloneInfos
          }

          // INOYA
          if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7' || this.$store.state._User.entKey === '948580a42a7ace75df2befcdf0ec8a81') {
            for (let c in MOTIFS_INOYA) {
              if (MOTIFS_INOYA[c].value === infos['motif']) {
                infos['motifToShow'] = MOTIFS_INOYA[c].text
              }
            }
          }
          this.leadsDetails.push(infos)
        })
*/
        _.each(this.resFromAjax.leads2, lead => {
          let infos2 = {}
          // pour chaque attributs du lead
          _.each(lead, (value, key) => {
            // recheche la source du lead
            if (key === 'source') {
              if (value === 'agent') {
                this.nbLeadsChat++
              } else if (value === 'bot') {
                this.nbLeadsBot++
              } else if (value === 'form') {
                this.nbLeadsForm++
              } else if (value === 'c2c') {
                this.nbLeadsCallBack++
              } else if (value === 'rdv') {
                this.nbLeadsMeeting++
              } else {
                this.nbLeadsAutre++
              }
            }
            infos2[key] = value // ajoute uniquement si autorisé
            // formatage s'il s'agit d'une date
            if (moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD') === value) {
              infos2[key] = moment(value).format('L')
            }
          })
          // returning lead
          if (infos2['creation'] < infos2['last']) {
            // this.returningLead++
          }
          // formatage des infos2 getquanty si autorisé
          if (this.brideMenu('stats_leads_getquanty') === '1') {
            try {
              infos2['getquanty'] = JSON.parse(infos2['getquanty'])
            } catch (e) {
              infos2['getquanty'] = ''
            }
          } else {
            infos2['getquanty'] = ''
          }
          // formatage du domain du site
          // infos2['siteId'] = infos2['site']
          // infos2['site'] = this.GET_SITE_BY_ID(infos2['id_lic']).LIC_URL
          if (infos2['url'] !== '') {
            infos2['site'] = infos2['url']
          } else {
            infos2['site'] = infos2['host']
          }
          infos2['site'] = new window.URL(infos2['site']).hostname
          // infos2['siteKey'] = infos2['siteKey']
          infos2['motifToShow'] = infos2['motif']

          // uniquement pour
          // BNPPRE
          if (this.$store.state._User.entKey === 'adad9e37fb749c6884c852') {
            // let cloneInfos2 = _.cloneDeep(infos2)
            // let testObjInfos2 = Object.keys(infos2.champSup.name)// un tableau de cles champssup
            // ajoute les champsSup remplis
            // for (let a = 0; a < infos2['champSup'].length; a++) {
            //   let name = infos2['champSup'][a].name
            //   let val = infos2['champSup'][a].value
            //   // let obj = '{' + name + ': ' + value + '}'
            //   infos2[name] = val
            // }
            // ajoute les champsSup bot uniquement si pas encore dans l'objet "infos2"
            for (let i = 0; i < this.nameChampsBot.length; i++) {
              let find = false
              // recheche si il existe deja une entrée dans l'object infos2.champSup
              for (let a = 0; a < infos2['champSup'].length; a++) {
                if (infos2['champSup'][a].name === this.nameChampsBot[i]) {
                  let name = infos2['champSup'][a].name
                  let val = infos2['champSup'][a].value
                  // let obj = '{' + name + ': ' + value + '}'
                  infos2[name] = val
                  find = true
                }
              }
              if (!find) {
                infos2[this.nameChampsBot[i]] = ''
              }
              // let indexChamp = infos2.champSup.findIndex(info => info.name === this.nameChampsBot[i])
              // // si pas encore present on l'ajoute sans valeur
              // if (indexChamp === -1) {
              //   infos2[this.nameChampsBot[i]] = ''
              // // sinon on l'ajoute avec la valeur deja présente
              // // } else {
              //   // let name = infos2['champSup'][indexChamp].name
              //   // let val = infos2['champSup'][indexChamp].value
              //   // let obj = '{' + name + ': ' + value + '}'
              //   // infos2[name] = val
              // }
            // var test = infos2.find(infos2, function (o) { return o === this.nameChampsBot[i] })
            }
            // infos2 = cloneInfos2
          }

          // INOYA
          if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7' || this.$store.state._User.entKey === '948580a42a7ace75df2befcdf0ec8a81') {
            for (let c in MOTIFS_INOYA) {
              if (MOTIFS_INOYA[c].value === infos2['motif']) {
                infos2['motifToShow'] = MOTIFS_INOYA[c].text
              }
            }
          }
          if (infos2['source'] === 'bot' && this.brideMenu('stats_chatbot') !== '1') {
            // ne pas mettre à jour le tableau
          } else if (infos2['source'] === 'c2c' && this.brideMenu('stats_callback') !== '1') {
            // ne pas mettre à jour le tableau
          } else {
            this.leadsDetails2.push(infos2)
          }
          // console.log('infos2', infos2)
        })
        // console.log('this.leadsDetails2', this.leadsDetails2)
        // console.log('nbLeadsChat', this.nbLeadsChat)
        // console.log('nbLeadsBot', this.nbLeadsBot)
        // console.log('nbLeadsCallBack', this.nbLeadsCallBack)
        // console.log('nbLeadsForm', this.nbLeadsForm)
        // console.log('nbLeadsAutre', this.nbLeadsAutre)
      })
      .catch(errors => {})
      .then(_ => {
        // this.loading = false
        // console.log('passe par la : getLeadsInfo')
        this.getLeads()
      })
    },

    /**
     * Récupère le nombre de conversation des leads sur la période
     */
    getLeads () {
      // console.log('--> getLeads')
      this.loading = true
      this.axios.get('get/stats_leads.php?' + this.params)
        .then((res) => {
          // this.nbCreations = res.data.nbLeads
          this.nbChats = res.data.nbChats
          // this.options.xAxis.categories = []
          // this.options.series[7].data = []
          this.options.series[7].data = []

          // informations du graphique
          res.data.days.forEach(day => {
            // console.log('day.chats', day.chats)
            // infos jour par jour
            // this.options.xAxis.categories.push(moment(day.date).format('ll'))
            // this.options.series[7].data.push(day.chats)
            this.options.series[7].data.push(day.chats)
          })
        })
        .catch((e) => console.error(e))
        .then(() => {
          this.loading = false
          console.log('start requet getAgentsChats')
          this.getAgentsChats()
          // console.log('this.options.series', this.options.series)
        })
    },

    /**
     * Récupère les chats par agents
     */
    getAgentsChats () {
      let sizeOptionSeries = this.options.series.length
      this.totalChatsAgent = 0
      this.loading = true
      this.axios.get('get/agents_chats.php?' + this.params)
      .then(response => {
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        // this.agentsChatsPie.series = [{}]
        // this.agentsChatsPie.series[0].data = []
        // this.agentsChatsBar.series = []
        // this.agentsChatsBar.xAxis.categories = []
        // Maj du camembert (part des chats/agent)
        // et ajout des series pour les agents du graph colonnes
        let idAgents = []
        // let nbChats = 0
        response.data.chatsByAgent.forEach(agent => {
          // change l'id par le nom de l'agent parmis les agents sélectionné
          let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(agent.id)})
          // this.agentsChatsPie.series[0].data.push({
          //   name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
          //   agentID: agent.id,
          //   y: agent.pourcent,
          //   chats: agent.nb
          // })
          // incrémentation du nombre de chat totaux
          // nbChats += agent.nb
          idAgents.push(agent.id)
          this.options.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            stack: 'chats',
            type: 'column',
            yAxis: 1,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            data: []
          })
        })

        // name: 'leads conseiller',
        //     type: 'column',
        //     color: 'rgba(156, 39, 176, 0.9)', // purple
        //     marker: {symbol: 'circle', enabled: false},
        //     visible: true,
        //     tooltip: { valueSuffix: '' },
        //     yAxis: 1,
        //     stack: 'leads',

        // Maj du titre indiquant le total de chats
        // this.agentsChatsPie.title.text = _.upperFirst(this.$tc('distributionOfChats', 1, {count: nbChats}))
        // Maj des colonnes stackées (data par jour)
        // pour chaque jour
        // console.log('response.data', response.data)
        Object.entries(response.data.days).forEach(([date, agents]) => {
          // ajout des jours dans l'axe des X
          this.options.xAxis.categories.push(moment(date).format('ddd D MMM YY'))
          // ajout des données dans l'axe des Y
          // pour chaque agent
          Object.entries(agents).forEach(([id, chat]) => {
            // console.log('id', id)
            let idx = idAgents.findIndex(i => i === _.toNumber(id))
            // console.log('idx', idx)
            if (idx !== -1) {
              // if (idx >= sizeOptionSeries && this.options.series[idx]) {
              let i = idx + sizeOptionSeries
              this.options.series[i].data.push(chat)
              this.totalChatsAgent += chat
              // }
            }
          })
        })
        // console.log('this.options', this.options)
        // console.log('totalChatsAgent', this.totalChatsAgent)
      })
      .catch()
      .then(_ => {
        this.loading = false
      })
    },
    // getChats () {
    //   this.loading = true
    //   // execution de la requête en fonction des filtres
    //   this.axios.get('get/chats_by_agent_filter.php?' + this.params)
    //   .then(response => {
    //     this.nbChats = response.data.chatsOK
    //     console.log('this.nbChats', this.nbChats)
    //   })
    //   .catch(errors => {})
    //   .then(_ => {
    //     this.loading = false
    //   })
    // },

    /**
     * Dialogue d'édition d'un lead
     */
    openDialogEdit (lead) {
      // console.log('openDialogEdit', lead)
      this.dialogEdit = true
      this.leadDialog = {}
      this.leadDialog = _.clone(lead)
      // this.$refs.tabs.slider()
      // console.log('this.leadDialog', lead)

      let listeMotifs = []
      for (let n in this.$store.state._Sites.sites) {
        // console.log(this.$store.state._Sites.sites[n].LIC_KEY + ' === ' + lead.siteKey)
        // console.log('customLead.motifs', newTab.motifs)
        if (this.$store.state._Sites.sites[n].LIC_KEY === lead.siteKey) {
          let customLead = this.$store.state._Sites.sites[n].DSK_CUSTOM_LEAD_FORM
          // console.log('customLead', customLead)
          if (customLead !== '') {
            for (let i = 0; i < customLead.motifs.length; ++i) {
              let label = customLead.motifs[i]
              if (label === 'support') {
                label = 'Support'
              } else if (label === 'lead') {
                label = 'Prospect qualifié'
              } else if (label === 'sale') {
                label = 'Vente'
              } else if (label === 'resa') {
                label = 'Réservation'
              } else if (label === 'devis') {
                label = 'Devis'
              } else if (label === 'contact') {
                label = 'Contact'
              }
              listeMotifs.push({
                text: label,
                value: customLead.motifs[i]
              })
            }
            if (listeMotifs.length !== 0) {
              this.default_motif = listeMotifs
            } else {
              this.default_motif = []
            }
          }
        }
      }
      this.custom_motifs = listeMotifs
      // console.log('lead.champSup', lead.champSup)
      // il faut retirer les customChamp non rempli
      let newArrayCustomChamp = []
      // let motTest = 'bot_TF'
      // ---------------uniquement si il y a un bot ou pour BNP
      if (this.$store.state._User.entKey === 'adad9e37fb749c6884c852') {
        // lead.champSup.forEach(function (item) {
        //   if (item.value || item.name.includes(motTest)) {
        //     // console.log('item', item)
        //     newArrayCustomChamp.push(item)
        //   }
        // })
        for (let i = 0; i < this.nameChampsBot.length; i++) {
          let find = false
          for (let a = 0; a < lead.champSup.length; a++) {
            // si le nom est deja dans le tableau
            if (lead.champSup[a].name === this.nameChampsBot[i]) {
              newArrayCustomChamp.push({'name': lead.champSup[a].name, 'value': lead.champSup[a].value})
              find = true
            }
          }
          if (!find) {
            newArrayCustomChamp.push({'name': this.nameChampsBot[i], 'value': ''})
          }
        }
      } else {
        lead.champSup.forEach(function (item) {
          if (item.value) {
            // console.log('item', item)
            newArrayCustomChamp.push(item)
          }
        })
      }
      // ---------------------------------------------
      this.custom_champs = newArrayCustomChamp
      // console.log('custom_champs', this.custom_champs)
    },

    dialogEditeurRemove () {
      this.dialogEdit = false
    },
    // update les données du tableau leads avec le lead modifié
    updateLeadSubmit (leadUpdate) {
      // console.log('updateLeadSubmit', leadUpdate)
      this.leadDialog = {}
      this.leadDialog = _.clone(leadUpdate)
      // remplacer le lead qui doit être modifié par celui dans le dialog
      let indexOfLead = _.findIndex(this.leadsDetails2, { id: this.leadDialog.id })
      this.$set(this.leadsDetails2, indexOfLead, this.leadDialog)
    },

    /**
     * Dialogue de suppression des informations d'un lead
     * @param {Object} lead le lead à suprrimer
     */
    openDialogRemove (lead) {
      this.dialogRemove = true
      this.leadDialog = _.clone(lead)
    },
    cancelDialogRemove () {
      this.dialogRemove = false
    },
    submitDialogRemove () {
      this.dialogRemove = false
      // supprime les infos du lead de la BDD
      let dataToPost = new window.FormData()
      dataToPost.append('session', this.leadDialog.id)
      this.axios.post('delete/lead.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // supprimer le lead de la liste des leads
        let indexOfLead = _.findIndex(this.leadsDetails2, { id: this.leadDialog.id })
        this.leadsDetails2.splice(indexOfLead, 1)
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `Lead supprimé`, context: 'success'})
      })
    },

    /**
     * Fonction de filtrage des leads
     * @param  {Array} items  liste des leads
     * @param  {String} search chaine recherchée
     * @param  {Function} filter fonction de recherche
     * @return {Array}        liste des leads filtrés
     */
    filterLeads (items, search, filter) {
      // console.log('items', items)
      // console.log('search', search)
      // console.log('filter', filter)
      // Affichage des leads qui
      // sont dans la période de recherche
      if (this.leadsOfPeriod) {
        // console.log('leadsOfPeriod')
        items = _.filter(items, item => {
          return this.onlyCreatedLeads
            ? this.isInPeriod(item.creation)
            : this.isInPeriod(item.creation) || this.isInPeriod(item.last)
        })
      }

      // infos getQuanty
      if (this.getquanty) {
        // console.log('getquanty', this.getquanty)
        items = _.filter(items, item => {
          return _.isObject(item.getquanty)
        })
      }

      // les returning leads uniquement
      if (this.sourceReturning) {
        items = _.filter(items, item => {
          // console.log(item.creation + '!==' + item.last)
          if (item.creation !== item.last) {
            return item.last
          }
        })
      }

      // lead enregistré par un agent
      if (this.sourceAgent) {
        items = _.filter(items, item => {
          if (item.source === 'agent') {
            return item.source
          }
        })
      }

      // lead enregistré par un bot
      if (this.sourceBot) {
        items = _.filter(items, item => {
          if (item.source === 'bot') {
            return item.source
          }
        })
      }

      // lead issus du recall (vyte ou autre)
      if (this.sourceRecall) {
        items = _.filter(items, item => {
          if (item.source === 'rdv') {
            return item.source
          }
        })
      }

      // lead enregistré par un formulaire
      if (this.sourceForm) {
        items = _.filter(items, item => {
          if (item.source === 'form') {
            return item.source
          }
        })
      }

      // C2C ?
      if (this.C2C) {
        // console.log('C2C')
        items = _.filter(items, item => {
          if (item.source === 'c2c') {
            return item.source
          }
        })
      }

      // Motifs et motifs ORPI
      if (this.motif) {
        // console.log('--motif--', this.motif)
        items = _.filter(items, item => {
          // console.log('item.motif', item.motif)
          // return _.indexOf(item.motif, this.motif) !== -1 || _.indexOf(item.motifToShow, this.motif) !== -1
          if (item.motif === this.motif) {
            return item.motif
          }
          // return item.motif
        })
      }

      // Motifs et motifs ORPI
      // if (this.custom_champs) {
      //   items = _.filter(items, item => {
      //     return _.indexOf(item.motifs, this.motif) !== -1 || _.indexOf(item.motif, this.motif) !== -1
      //   })
      // }

      this.filteredLeads = items
      if (_.isNil(search)) return items

      search = search.toString().toLowerCase()
      items = items.filter(i => (
        Object.keys(i).some(j => filter(i[j], search))
      ))
      // console.log('items', items)
      this.filteredLeads = items
      return items
    },

    /**
     * Fonction de tri
     * @param  {Array}  items         liste des leads
     * @param  {Number}  index        indice
     * @param  {Boolean} isDescending [description]
     * @return {Array}                liste des leads triés
     */
    sort (items, index, isDescending) {
      if (index === null || items.length <= 1) return items

      let itemsSorted = items
      // cas d'une date moment
      if (index === 'last' || index === 'creation') {
        itemsSorted = _.sortBy(items, [item => {
          if (item[index] === '') return 0
          return moment(item[index], 'L').unix()
        }])
      } else if (index === 'duration') {
        itemsSorted = _.sortBy(items, [item => { return _.toNumber(item[index]) }])
      } else {
        itemsSorted = _.sortBy(items, [item => { return item[index] }])
      }
      if (isDescending) return itemsSorted.reverse()
      return itemsSorted
    },

    /**
     * Fonctions d'export de lead
     */
    leadMail (lead) {
      // envoie les infos du lead par mail
      let dataToPost = new window.FormData()
      for (let key in lead) {
        dataToPost.append(key, lead[key])
      }
      this.axios.post('post/lead_mail.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `Lead envoyé par mail`, context: 'success'})
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `L'envoi du lead a échoué`, context: 'error'})
      })
    },
    leadZendesk (lead) {
      // créer un ticket zendesk avec le lead
      let dataToPost = new window.FormData()
      for (let key in lead) {
        dataToPost.append(key, lead[key])
      }
      this.axios.post('post/lead_zendesk.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `Ticket Zendesk créé`, context: 'success'})
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `La création d'un ticket Zendesk a échoué`, context: 'error'})
      })
    },
    leadSalesForce (lead) {
      // envoie les infos du lead sur SalesForce
      let dataToPost = new window.FormData()
      for (let key in lead) {
        dataToPost.append(key, lead[key])
      }
      this.axios.post('post/lead_salesforce.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `Export vers SalesForce réussi`, context: 'success'})
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {message: `L'export vers SalesForce a échoué`, context: 'error'})
      })
    },

    /**
     * Télécharge la liste des leads en CSV
     */
    // download2 () {
    //   this.$router.push({ path: '/csvExport' })
    // },

    download () {
      // console.log('this.filteredLeads', this.filteredLeads)
      let csv = null
      let fields = this.filteredLeads[0]
      delete fields.motifs
      delete fields.siteId
      fields = _.keys(fields)
      let fieldNames = _.map(fields, field => {
        return field === 'id' || field === 'ip'
          ? field
          : this.$tc(_.camelCase('export ' + field), 2, { count: '' })
      })
      // formatage
      let dataToExport = this.filteredLeads.map(lead => {
        // console.log('lead', lead)
        let agent = this.$store.getters['_User/getUserById'](lead.agent)
        lead.agent = agent
          ? agent.USR_FIRST_NAME + ' ' + agent.USR_LAST_NAME
          : ''
        return lead
      })
      try {
        csv = json2csv({
          data: dataToExport,
          fields: fields,
          del: ';',
          newLine: '\r\n',
          fieldNames: fieldNames
        })
        // window.open('./static/viewCSV.php', '_blank')
        // this.$router.push({ path: '/csvexport' })
      } catch (err) {
        console.err(err)
        return
      }
      // si il y a trop de lead on affiche le resultat
      // console.log('this.nbVisits', this.nbVisits)
      if (this.nbVisits > 500) {
        this.$router.push({ name: 'csvexport', params: { 'csv': csv } })
      // sinon on export directement en csv
      } else {
        // téléchargement du fichier csv
        let paramsArray = this.params.split('=')
        let debut = paramsArray[1].substring(0, 10)
        let fin = paramsArray[2].substring(0, 10)
        let nameFile = 'leads_du_' + debut + '_au_' + fin + '.csv'

        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = nameFile
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
      }
    },

    /**
     * Helpers
     */
    agentIdToAgentName (id) {
      return this.leadsDetails2.map(agent => {
        let found = _.find(this.$store.state._User.colleagues, {
          'USR_ID': _.toString(id)
        })
        // console.log('found', found)
        return !_.isNil(found)
        ? found.USR_FIRST_NAME + ' ' + found.USR_LAST_NAME
        : ''
      })
    },
    isInPeriod (date) {
      if (_.isNil(date) || _.isEmpty(date)) {
        return false
      }
      return moment(date, 'L').isBetween(
        this.$store.state._Stats.dateStart,
        this.$store.state._Stats.dateEnd,
        'days',
        '[]'
      )
    },
    /**
     * Calcul de la chaleur d'un lead
     */
    chaleur (idlead) {
      for (let i in this.leadsDetails2) {
        if (this.leadsDetails2[i].id === idlead) {
          return this.chaleurLead(this.leadsDetails2[i]).chaleur
        }
      }
      return ''
    },
    // chaleur du lead uniquement pas de detail
    // les details sont dans la dialogBox editeur de lead
    chaleurLead (lead) {
      // console.log('lead', lead)
      let chaleur = 0
      let points = 0
      // Nb visite de page panier : 1pt par visite
      points = lead.basket * 1
      chaleur += points

      // Visiteur a chatté : 10pts
      points = lead.hasChatted
        ? 10
        : 0
      chaleur += points

      // Visiteur ciblé : 10pts
      points = lead.hasBeenTarget
        ? 10
        : 0
      chaleur += points

      // Duree de présence sur site : 1pt par 5 minutes
      points = _.round((lead.duration / 60) / 5)
      chaleur += points

      // Email : 10pts
      points = !_.isEmpty(lead.email)
        ? 10
        : 0
      chaleur += points

      // Tel : 10pts
      points = !_.isEmpty(lead.tel) || !_.isEmpty(lead.C2C)
        ? 10
        : 0
      chaleur += points

      // Ventes passees : 10pts par vente
      points = lead.purchase * 10
      chaleur += points

      return {
        chaleur: chaleur
      }
    }
  },

  watch: {
    params (v) {
      this.loading = true
      this.getLeadsInfos()
      // this.getLeads()
      // this.getLeads()
      // this.getChats()
    },
    leadsOfPeriod (v) {
      if (!v) {
        this.onlyCreatedLeads = false
      }
    }
  },

  filters: {
    duration: function (v) {
      return moment.duration(_.toNumber(v), 'seconds').format('h [h] mm [min] ss [s] ')
    }
  }
}
</script>

<style>
  .choixLead {margin-top: 0px !important;}
  .returningLeads {margin-left: 10px!important;}
</style>



// WEBPACK FOOTER //
// src/components/stats/Leads.vue